import { render, staticRenderFns } from "./Main360Icon.vue?vue&type=template&id=db572962&scoped=true&"
import script from "./Main360Icon.vue?vue&type=script&lang=js&"
export * from "./Main360Icon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "db572962",
  null
  ,true
)

export default component.exports